import { useState } from 'react';
import { toast } from 'sonner';
import { axiosInstance } from '@/App';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

/**
 * Quién ha consultado o exportado el registro de otras personas, y cuándo.
 * Se carga solo al abrirlo: es para rendir cuentas (RGPD), no para el día a día.
 */
const ACCIONES = {
  ver_equipo: 'consultó el equipo',
  ver_excesos: 'consultó las horas del mes',
  exportar_csv: 'exportó en CSV',
  exportar_pdf: 'exportó en PDF',
};

export function RegistroAccesos({ zona }) {
  const [lista, setLista] = useState(null);

  const abrir = async () => {
    try {
      const r = await axiosInstance.get('/fichajes/accesos');
      setLista(r.data);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'No se ha podido cargar');
    }
  };

  const cuando = (ts) => new Intl.DateTimeFormat('es-ES', {
    timeZone: zona, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  }).format(new Date(ts));

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle className="text-base">Quién ha consultado el registro</CardTitle>
        {!lista && <Button size="sm" variant="outline" onClick={abrir}>Ver</Button>}
      </CardHeader>
      {lista && (
        <CardContent className="text-sm space-y-1">
          {lista.length === 0 && <p className="text-slate-500">Nadie todavía.</p>}
          {lista.map((a) => (
            <p key={a.id} className="text-slate-700">
              <span className="tabular-nums text-slate-500 mr-2">{cuando(a.ts)}</span>
              {a.nombre} {ACCIONES[a.accion] || a.accion}
              {a.detalle ? ` (${a.detalle})` : ''}
              {a.suplantado_por ? ` · sesión suplantada por ${a.suplantado_por}` : ''}
            </p>
          ))}
        </CardContent>
      )}
    </Card>
  );
}
